import React, { useCallback, useEffect, useMemo, useState } from 'react'
import Slider from 'react-slick'
import { useHistory, NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { LOADER_HANDLER_TYPES, ROUTE_PATHS } from 'constants/index'
import {
  addFavouriteGame,
  getCasinoGamesList,
  removeFavouriteGame
} from 'redux-thunk/thunk/game.thunk'
import { GameImg } from 'pages/GameImage/index'
import { getAuthToken } from 'helpers/cookie.helpers'
import FavouriteIcon from 'components/molecules/FavouriteIcon/index'
import { openWarningToaster } from 'helpers/toaster.helpers'
import Loader from 'components/ui-kit/Loader/index'
import { casinoHeading, defaultGameImage } from 'components/ui-kit/Icons/png/index'
import ContentHeader from 'components/ui-kit/ContentHeader/index'
import { CasinoMenuIcon } from 'components/ui-kit/Icons/svg/index'
import { uniqBy } from 'lodash'

const CasinoSection = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const isLoggedIn = getAuthToken()
  const { user } = useSelector((state) => state.user)
  const { categoryWiseGamesList, casinoCategoriesList } = useSelector(
    (state) => state.games
  )
  const {
    [LOADER_HANDLER_TYPES.submit]: loading,
    [LOADER_HANDLER_TYPES.categoryWiseGamesList]: gamesLoading
  } = useSelector((state) => state.loader)
  const [gameId, setGameId] = useState(null)
  const [games, setGames] = useState([])

  const onGamePlayRedirect = useCallback(
    (game) => {
      const gameName = game?.gameName?.toLowerCase().replace(/\s+/g, '-')
      if (isLoggedIn) {
        history?.push(`/casino/play-game/${gameName}`, { game, demo: false })
      } else if (game.hasDemo) {
        history?.push(`/casino/play-game/${gameName}`, { game, demo: true })
      } else {
        openWarningToaster({ message: t('LoginRequired') })
      }
    },
    [isLoggedIn]
  )

  const handleFavouriteGame = (e, game) => {
    setGameId(game?.id)
    e.stopPropagation()
    if (game?.isFavourite) {
      dispatch(removeFavouriteGame({ game }))
    } else {
      dispatch(addFavouriteGame({ game }))
    }
  }

  const handleClickAllGames = (e) => {
    e.preventDefault()
    history.push(ROUTE_PATHS.CASINO)
  }

  const getGames = () => {
    for (let index = 0; index < 2; index++) {
      dispatch(
        getCasinoGamesList({
          data: {
            offset: 0,
            limit: 20,
            type: index === 1 ? 'live casino' : 'slot game',
            userId: user?.id,
            provider: index === 1 ? 170 : 2 // 2: Pragmatic, 170: Evolution provider id
          }
        })
      )
    }
  }

  useEffect(() => {
    if (!loading) {
      setGameId(null)
    }
  }, [loading])

  useEffect(() => {
    if (casinoCategoriesList?.length > 0) {
      if (isLoggedIn && user?.id) {
        getGames()
      } else if (!isLoggedIn) {
        getGames()
      }
    }
  }, [casinoCategoriesList, user?.id])

  useEffect(() => {
    if (categoryWiseGamesList) {
      const liveCasinoGames = categoryWiseGamesList?.filter(el => el?.type === 'live casino')
      const slotGames = categoryWiseGamesList?.filter(el => el?.type === 'slot game')
      const resultArray = uniqBy([...liveCasinoGames, ...slotGames]?.reverse(), 'type')
      setGames(resultArray)
    }
  }, [categoryWiseGamesList])

  const homeCasinoSettings = useMemo(
    () => ({
      initialSlide: 0,
      dots: false,
      infinite: false,
      arrows: true,
      speed: 600,
      autoplay: false,
      slidesToShow: 7,
      slidesToScroll: 7,

      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    }),
    []
  )

  return (
    <>
      {
        games?.slice(0, 2)?.map((item, index) => (
          <section key={item.type} className='global-casino-section'>
            <ContentHeader
              title={index === 0 ? t('casino') : item.type}
              subtitle={t('allGames')}
              Icon={index === 0 ? CasinoMenuIcon : (item.image || casinoHeading)}
              iconType={index === 0 ? '' : 'png'}
              subtitleOnClickHandler={handleClickAllGames}
            />
            <div className='slide-wrap p-0 m-0'>
              {gamesLoading && <Loader variant={LOADER_HANDLER_TYPES.content} />}
              <Slider {...homeCasinoSettings}>
                {item?.rows?.length > 0 &&
            item?.rows?.map((game) => (
              <div key={game?.casinoGameId} className='col px-06'>
                <div className='theme-card-wrap'>
                  <div className='theme-card'>
                    <div className='casino-img-wrap'>
                      <GameImg
                        imgSrc={
                          game?.image ||
                          defaultGameImage
                        }
                      />
                      <div
                        className='card-overlay'
                        onClick={() => onGamePlayRedirect(game)}
                      >
                        <h4>Play Now</h4>
                        <p>$1,130.33</p>
                        {isLoggedIn && (
                          <NavLink
                            to='#'
                            onClick={(e) => handleFavouriteGame(e, game)}
                          >
                            {loading && gameId === game?.id
                              ? (
                                <Loader variant={LOADER_HANDLER_TYPES.submit} />
                                )
                              : (
                                <FavouriteIcon
                                  fill={game?.isFavourite ? 'red' : 'none'}
                                />
                                )}
                          </NavLink>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
              </Slider>
            </div>
          </section>))
}
    </>
  )
}

export default React.memo(CasinoSection)
